/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { postMessageToClient } from '../chatservice/communicationService';
import { updateAnalyticsStatus } from '../chatservice/dialogflowQuery';
import { MessageTypes } from '../models/enum';
import './message.scss';

type messageLinkProps = {
    text: string,
    link: string,
    sessionId?: any,
    userId?: any,
    intentGroupId?: any,
    type?: any
}

const MessageLink = ({text, link, sessionId, userId, intentGroupId, type }: messageLinkProps) => {
    const onClickHandler = () => {
        postMessageToClient({name: "chatbotQRClicked", text: text});

        // if message type is DQR post a success to analytics when clicked.
        if (type === MessageTypes.DynamicQr) {
            updateAnalyticsStatus(sessionId, userId, intentGroupId, true);
        }
    }
    
    const externalLink = (type && (type === MessageTypes.Form || type === MessageTypes.DynamicQr)  && sessionId && userId && intentGroupId) ? `${link}&msid=${sessionId}&muid=${userId}&migid=${intentGroupId}` : link;

    return (
        <div className='message__text--quick-reply'>           
            <a href={externalLink} onClick={onClickHandler} className="message__link" target="_blank" rel="noreferrer">{text}</a>           
        </div>
    )
}

export default MessageLink
